export enum AssessmentType {
  None = 0,
  Stream = 1,
  Career = 2,
}
export const AssessmentTypeDescriptions: {[key in AssessmentType]: string} = {
  [AssessmentType.None]: "None",
  [AssessmentType.Career]: "Career",
  [AssessmentType.Stream]: "Stream",
}